<template>
    <BaseWidget :title="widget.title" :title-url="widget.titleUrl">
        <EmptyState
            :title="widget.content.empty_state_message"
            with-icon
            v-if="widget.content.activities.length === 0"
        />
        <div class="divide-y-2 divide-gray-100">
            <div class="flex justify-between py-2" v-for="activity in widget.content.activities" :key="activity.id">
                <div>
                    {{ activity.title }}
                </div>
                <div>
                    <span
                        class="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium"
                        :class="[activity.classes]"
                    >
                        {{ activity.letterScore }}
                    </span>
                </div>
            </div>
        </div>
    </BaseWidget>
</template>

<script>
import BaseWidget from '@/components/Widgets/BaseWidget.vue';
import EmptyState from '@/components/EmptyState.vue';

export default {
    name: 'LatestActivityResponsesWidget',
    props: {
        widget: {
            required: true,
            type: Object,
        },
    },
    components: {
        EmptyState,
        BaseWidget,
    },
};
</script>
